import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {AgencyClientsContent} from "./AgencyClientsContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencyClients extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulAgencyClientSubmit = this.afterSuccessfulAgencyClientSubmit.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    afterSuccessfulAgencyClientSubmit(newAgencyClientId, newAgencyClientName) {
        this.props.history.push(`/client/${newAgencyClientId}/`);
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <AgencyClientsContent agencyId={this.props.match.params.id}
                                      redirectToAgencyRegisterPage={this.redirectToAgencyRegisterPage}
                                      afterSuccessfulAgencyClientSubmit={this.afterSuccessfulAgencyClientSubmit}
                />
            </div>
        )
    }
}

export default withRouterParams(AgencyClients);



